import request  from "@/utils/request.js";
// 密码重置
export function setnewpass(data) {
  return request({
    url: '/isp/user/setnewpass',
    method: 'post',
    data
  })
}

// 忘记密码--用户名手机号校验（1）
export function retrievepass(params) {
  return request({
    url: '/infor/retrievepass',
    method: 'get',
    params
  })
}

// 忘记密码-设置密码提交（2）
export function upretrievepass(params) {
  return request({
    url: '/infor/upretrievepass',
    method: 'get',
    params
  })
}
